import { render } from "./Region.vue?vue&type=template&id=44ea7c3a&scoped=true"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"

import "./Region.vue?vue&type=style&index=0&id=44ea7c3a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ea7c3a"]])

export default __exports__